const $ = require('jquery');
// const TweenMax = require('gsap/src/uncompressed/TweenMax');
const forEach = require('lodash.foreach');
// const ScrollMagic = require('scrollmagic');
// require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');

import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenMax, TimelineMax } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

const controller = new ScrollMagic.Controller();


// init all the animation functions
initGeneralCascades();
initUserFunnelTitles();


//------------------------------------------------------------------
// Begin Animation #1: Cascading in on just about everything.
//------------------------------------------------------------------

function initGeneralCascades() {
  // Elements that will act as triggers for the cascading animation.
  var $els = $('#homepage-mission .mission, #homepage-mission .stats h2, #homepage-mission .stats p, .two-col-user-funnel-wrapper > .col-inner').not('.no-animation');

  // Set in a foreach since there can be more than one on a page.
  forEach($els, element => {

    var $this = $(element);
    var travelDistance = window.innerWidth < 1000 ? 50 : 80;

    // Move the content up.
    var cascadeItem = TweenMax.fromTo(element, 1, {
        y: travelDistance,
        opacity: 0,
        ease: Power3.easeInOut,
      },
      {
        y: 0,
        opacity: 1,
        ease: Power3.easeInOut,
      }
    );

    // Use ScrollMagic to trigger the animations when the specific elements are scrolled to.
    new ScrollMagic.Scene({
      triggerElement: element,
      triggerHook: 'onEnter',
      reverse: false,
    })
      .setTween(cascadeItem)
      .addTo(controller);
  });
}



//------------------------------------------------------------------
// Begin Animation #2: User Funnel Titles
//------------------------------------------------------------------

function initUserFunnelTitles() {
  // First need to split each User Funnel Title into words and then wrap in span tags.
  $('.user-funnel-title').each((index, element) => {

    var $this = $(element);

    // Store the words.
    var words = $this.text().split(' ');
    // Empty the element.
    $this.empty();
    // Loop through the words and re-add them back to the original element.
    $.each(words, function(i, v) {
      $this.append($('<span>').html(v + '&nbsp;'));
    });

  });

  // Elements that will act as triggers for the cascading animation.
  const $userFunnelTitle = $('.user-funnel-title');

  // Set in a foreach since there can be more than one on a page.
  forEach($userFunnelTitle, element => {

    const $this = $(element);
    const travelDistance = window.innerWidth < 1000 ? 50 : 80;

    // Move the words of each title up one at a time.
    const tween = TweenMax.staggerTo($this.find('span'), .5, {
      y: 0,
      opacity: 1,
    }, .25);

    // Use ScrollMagic to trigger the animations when the specific elements are scrolled to.
    new ScrollMagic.Scene({
      triggerElement: element,
      triggerHook: 'onEnter',
      reverse: false,
    })
      .setTween(tween)
      .addTo(controller);
  });

}
